<template>
  <div class="margin-top">
    <el-row class="margin-top-lg" :gutter="0">
      <el-col :span="4">
        <el-input v-model.trim="receivedInfo.objName" placeholder="房屋编号" clearable />
      </el-col>
      <el-col :span="4">
        <el-input v-model.trim="receivedInfo.ownerName" placeholder="业主名称" clearable />
      </el-col>
      <el-col :span="4">
        <el-input v-model.trim="receivedInfo.link" placeholder="手机号" clearable />
      </el-col>
      <el-col :span="4">
        <el-button type="primary" size="small" @click="_queryReceivedByMonth">
          <i class="el-icon-search"></i>
          查询
        </el-button>
      </el-col>
      <el-col :span="8" class="text-right">
        <el-button type="primary" size="small" @click="_exportReceivedByMonth">
          <i class="el-icon-download"></i>
          <span>导出</span>
        </el-button>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="receivedInfo.fees" border style="width: 100%" v-loading="loading">
        <el-table-column prop="objName" label="房屋" align="center" />
        <el-table-column label="业主" align="center">
          <template slot-scope="scope">
            {{ scope.row.ownerName }}{{ scope.row.link ? '(' + scope.row.link + ')' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="receivedAmount" label="已收" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.receivedAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="actualReceivedAmount" label="实收" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.actualReceivedAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="feeName" label="费用项" align="center" />
        <el-table-column prop="curYearMonth" label="费用归属月份" align="center" />
        <el-table-column prop="createTime" label="收款时间" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="8">
          <span>已收合计：</span>
          <span>{{ formatMoney(receivedInfo.receivedAmount) }}</span>
        </el-col>
        <el-col :span="16" class="text-right">
          <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
            :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { queryMonthReceivedDetail, exportData } from '@/api/report/dataReportApi'

export default {
  name: 'DataReportReceivedByMonthStatistics',
  data() {
    return {
      loading: false,
      receivedInfo: {
        fees: [],
        objName: '',
        ownerName: '',
        link: '',
        receivedAmount: '0'
      },
      startDate: '',
      endDate: '',
      communityId: '',
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  methods: {
    open(param) {
      this.startDate = param.startDate
      this.endDate = param.endDate
      this.communityId = param.communityId
      this.page.current = 1
      this._loadReceivedByMonth()
    },
    async _loadReceivedByMonth() {
      this.loading = true
      try {
        const params = {
          page: this.page.current,
          row: this.page.size,
          communityId: this.communityId,
          feeStartDate: this.startDate,
          feeEndDate: this.endDate,
          objName: this.receivedInfo.objName,
          ownerName: this.receivedInfo.ownerName,
          link: this.receivedInfo.link
        }
        const { data, records, sumTotal } = await queryMonthReceivedDetail(params)
        this.receivedInfo.fees = data || []
        this.page.total = records || 0
        this.receivedInfo.receivedAmount = sumTotal || 0
      } catch (error) {
        console.error('Failed to load received by month data:', error)
      } finally {
        this.loading = false
      }
    },
    async _exportReceivedByMonth() {
      try {
        const params = {
          communityId: this.communityId,
          feeStartDate: this.startDate,
          feeEndDate: this.endDate,
          objName: this.receivedInfo.objName,
          ownerName: this.receivedInfo.ownerName,
          link: this.receivedInfo.link,
          pagePath: 'dataMonthReceivedStatistics'
        }
        const res = await exportData(params)
        this.$message.success(res.msg)
        if (res.code === 0) {
          this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
        }
      } catch (error) {
        console.error('Export failed:', error)
      }
    },
    _queryReceivedByMonth() {
      this.page.current = 1
      this._loadReceivedByMonth()
    },
    handleSizeChange(val) {
      this.page.size = val
      this._loadReceivedByMonth()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._loadReceivedByMonth()
    },
    formatMoney(value) {
      return Number(value || 0).toFixed(2)
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}

.margin-top-lg {
  margin-top: 30px;
}

.text-right {
  text-align: right;
}
</style>
